import { render, staticRenderFns } from "./MerchantOrderView.vue?vue&type=template&id=17b3fa6e"
import script from "./MerchantOrderView.vue?vue&type=script&lang=js"
export * from "./MerchantOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports